import { render } from "./TrueFalse.vue?vue&type=template&id=2e5375e0&scoped=true"
import script from "./TrueFalse.vue?vue&type=script&lang=js"
export * from "./TrueFalse.vue?vue&type=script&lang=js"

import "./TrueFalse.vue?vue&type=style&index=0&id=2e5375e0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5375e0"]])

export default __exports__